<template>
  <div>
    <split-screen>
      <template v-slot:left>
        <event-list :events="events" :filter="true" :tag="tag" prefix="tag" />
      </template>
      <template v-slot:right>
        <EventDetail v-if="events && currentEvent" :event="currentEvent" prefix="tag" />
        <div v-else class="absolute right-0 top-0 h-screen items-center flex text-6xl w-half-screen justify-center">
          <div class="border border-black rounded-full px-10 pt-4 f-serif uppercase">{{ catName($route.params.slug) }}</div>
        </div>
      </template>
    </split-screen>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SplitScreen from '@/views/SplitScreen'
import EventDetail from '@/components/EventDetail'
import EventList from '@/components/EventList'

export default {
  name: 'Tags',
  data () {
    return {
      items: false,
      artists: false,
      showGallery: false
    }
  },
  components: {
    EventDetail,
    EventList,
    SplitScreen
  },
  computed: {
    ...mapState(['events', 'lang']),
    tag () {
      return this.$route.params.slug
    },
    currentEvent () {
      if (this.$route.params.date && this.$route.params.slug) {
        return this.$store.getters.getCurrentEvent(this.$route.params.date, this.$route.params.currentItemSlug)
      } else {
        return false
      }
    },
    currentArtist () {
      return this.artists.find(x => {
        return x.slug === this.$route.params.slug
      })
    },
    artistImage () {
      if (this.currentArtist && this.currentArtist.images.length) {
        return this.currentArtist.images[0].medium
      } else {
        return false
      }
    },
    artistImages () {
      if (this.currentArtist && this.currentArtist.images.length) {
        return this.currentArtist.images
      } else {
        return false
      }
    },
    galleryImages () {
      if (this.artists) {
        return this.artists.map(x => {
          if (x.images.length) {
            return x.images[0].large
          } else {
            return false
          }
        })
      } else {
        return false
      }
    },
    description () {
      if (this.lang === 'en') {
        return this.currentArtist.description_en
      } else {
        return this.currentArtist.description_fr
      }
    }
  },
  methods: {
    catName (cat) {
      if (this.lang === 'en') {
        return cat.replace(/_/g, ' ')
      } else {
        return this.cats[cat]
      }
    },
    openGallery () {
      // this.showGallery = true
    },
    itemLink(item) {
      if (item.blueprint === "artist") {
        return `/artist/${item.slug}`
      } else {
        return `/calendar/${item.date}/${item.slug}`
      }
    }
  },
  mounted () {
    fetch(`${process.env.VUE_APP_API_ROOT}tag.json/${this.$route.params.slug}`)
      .then(res => res.json())
      .then(json => this.items = json)
  },
}
</script>

<style lang="stylus">
  a:hover .hidden, .router-link-exact-active .hidden
    display: inline-block

  .artist-image img
    @apply w-full


</style>
